import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-blogleftsidebar',
  templateUrl: './blogleftsidebar.component.html',
  styleUrls: ['./blogleftsidebar.component.css']
})
export class BlogleftsidebarComponent {
  @Input() selectedCategory: string = '';  // <-- ADD THIS LINE

  @Output() categorySelected = new EventEmitter<string>();

  selectCategory(cat: string) {
    this.categorySelected.emit(cat);
  }
}
